export var ApiRateLimitCategoryEnum;
(function (ApiRateLimitCategoryEnum) {
    ApiRateLimitCategoryEnum["TRIGGER"] = "trigger";
    ApiRateLimitCategoryEnum["CONFIGURATION"] = "configuration";
    ApiRateLimitCategoryEnum["GLOBAL"] = "global";
})(ApiRateLimitCategoryEnum || (ApiRateLimitCategoryEnum = {}));
